import { Capacitor } from "@capacitor/core";

const isApp = (): boolean => {
     return Capacitor.isNativePlatform()
}

export default isApp;